// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__1Mqbe","title":"card_title__lPXDX","inActive":"card_inActive__3ziAe"};